import { createSlice } from "@reduxjs/toolkit";

const queryIdSlice = createSlice({
  name: "queryId",
  initialState: {
    queryId: null,
  },
  reducers: {
    setQueryIdStore: (state, action) => {
      state.queryId = action.payload ?? null;
    },
    clearQueryIdStore: (state) => {
      state.queryId = null;
    },
  },
});

export const { setQueryIdStore, clearQueryIdStore } = queryIdSlice.actions;
export const selectStoredQueryId = (state) => state.queryId.queryId;
export default queryIdSlice.reducer;
